import { Box, ButtonBase, Typography, makeStyles } from '@material-ui/core'
import { CheckBox as CheckBoxOutline, CheckBoxOutlineBlank } from '@material-ui/icons'

import React from 'react'

interface ICheckbox {
  label?: string
  checked: boolean
  handleCheck: (value: boolean) => void
  color?: 'primary' | 'secondary'
}

const useStyles = makeStyles({
  root: {
    display: 'flex'
  }
})

export const Checkbox = (props: ICheckbox) => {
  const classes = useStyles()

  return (
    <ButtonBase
      onClick={() => {
        props.handleCheck(!props.checked)
      }}>
      <Box className={classes.root}>
        {props.checked ? <CheckBoxOutline color={props.color} /> : <CheckBoxOutlineBlank color={props.color} />}
        <Box width={7} />
        {props.label ? (
          <Typography variant='body1' color={props.color}>
            {props.label}
          </Typography>
        ) : null}
      </Box>
    </ButtonBase>
  )
}
